<ng-template #lightboxTpl>
  <ng-content></ng-content>
</ng-template>
